import Currency from '../../../../elements/Select/Currency'
import { dateVal, numVal } from '../../../../modules/Utils'
import React from 'react'
import { Button, Col, DatePicker, Form, Input, InputNumber, Statistic } from 'antd'
import { defaultFormItemLayout, rules } from '../../../../modules/FormItems'
import { get } from 'lodash'

PaymentPlanForm.propTypes = {}

function PaymentPlanForm (props) {
  const { getFieldDecorator, getFieldValue, setFieldsValue } = props.form
  const { paymentPlan, owner, list, isNew } = props

  let remaining, docAmount, totalPayLineAmount

  if (isNew) {
    docAmount = get(owner, 'subTotal.gross')
    totalPayLineAmount = list.reduce((acc, v) => numVal(v, 'amount') + acc, 0)
    remaining = docAmount - totalPayLineAmount
  } else {
    remaining =
      numVal(paymentPlan, 'subTotal.gross') -
      numVal(paymentPlan, 'totalPayLineAmount') -
      numVal(getFieldValue('amount'), '')

    docAmount = get(paymentPlan, 'subTotal.gross')
    totalPayLineAmount = get(paymentPlan, 'totalPayLineAmount')
  }

  console.log({ owner, list, isNew })
  return (
    <Form>
      <Col span={8}>
        <Statistic title="Document Amount" value={docAmount}/>
      </Col>
      <Col span={8}>
        <Statistic title="Total PayPlans Amount" value={totalPayLineAmount}/>
      </Col>
      <Col span={8}>
        <Statistic title="Remaining Amount" value={remaining}/>
        <Button
          style={{ marginTop: 16, marginBottom: 16, display: 'inline' }}
          onClick={() => setFieldsValue({ amount: remaining })}
          type="primary">
          Use Remaining Amount
        </Button>
      </Col>

      <Col span={12}>
        <Form.Item {...defaultFormItemLayout} label={'Name'}>
          {getFieldDecorator('name', {
            initialValue: get(paymentPlan, 'name') || `Payment ${list.length + 1}`,
            rules: rules.input,
          })(<Input placeholder={'Name. e.g Payment 1'}/>)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...defaultFormItemLayout} label="Amount">
          {getFieldDecorator('amount', {
            initialValue: get(paymentPlan, 'amount'),
            rules: rules.input,
          })(<InputNumber style={{ width: '100%' }}/>)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...defaultFormItemLayout} label={'Date'}>
          {getFieldDecorator('date', {
            initialValue: dateVal(paymentPlan, 'date'),
            rules: rules.select,
          })(<DatePicker style={{ width: '100%' }}/>)}
        </Form.Item>
      </Col>

      <Col span={12}>
        <Form.Item {...defaultFormItemLayout} label="Currency">
          {getFieldDecorator('currency', {
            initialValue: owner.currency,
            rules: rules.input,
          })(<Currency disabled={owner.currency} style={{ width: '100%' }}/>)}
        </Form.Item>
      </Col>
    </Form>
  )
}

export default Form.create()(PaymentPlanForm)
